import { gql } from "@apollo/client";

export const PRODUCTS = gql`
  query Products(
    $limit: Int!
    $offset: Int!
    $sorting_created_at: order_by
    $amount: order_by
    $data: products_bool_exp!
  ) {
    products(
      limit: $limit
      offset: $offset
      order_by: { updated_at: $sorting_created_at, sold_amount: $amount }
      where: $data
    ) {
      created_at
      description
      id
      name
      price
      disabled
      sold_amount
      product_image_url
      updated_at
      barcode
      category {
        id
        product_category_name
      }
      brand_name {
        name
      }
      product_variations {
        id
        price
        variation_name
        color
        has_direct_discount
        direct_discount_type
        direct_discount_value
        original_price
        direct_discount_start_date
        direct_discount_end_date
        direct_discount_label
      }
      # Direct discount fields
      has_direct_discount
      direct_discount_type
      direct_discount_value
      original_price
      direct_discount_start_date
      direct_discount_end_date
      direct_discount_label
      direct_discount_created_at
      direct_discount_updated_at
    }
    products_aggregate(where: $data) {
      aggregate {
        count
      }
    }
  }
`;

export const PRODUCT_BY_ID = gql`
  query Products_by_pk($id: uuid!) {
    products_by_pk(id: $id) {
      category {
        product_category_name
      }
      product_photos {
        id
        fk_product_id
        product_image_url
      }
      fk_product_category_id
      fk_brand_id
      created_at
      description
      id
      name
      price
      product_image_url
      show_reviews
      discount_eligible
      sold_amount
      barcode
      disabled
      product_variations {
        color
        created_at
        fk_product_id
        id
        price
        updated_at
        variation_image_url
        variation_name
        disabled
        # Direct discount fields for variations
        has_direct_discount
        direct_discount_type
        direct_discount_value
        original_price
        direct_discount_start_date
        direct_discount_end_date
        direct_discount_label
        direct_discount_created_at
        direct_discount_updated_at
      }
      brand_name {
        name
      }
      updated_at
      # Direct discount fields
      has_direct_discount
      direct_discount_type
      direct_discount_value
      original_price
      direct_discount_start_date
      direct_discount_end_date
      direct_discount_label
      direct_discount_created_at
      direct_discount_updated_at
    }
  }
`;

export const PRODUCT_VARIATIONS = gql`
  query Product_variations($product_id: uuid!) {
    product_variations(where: { fk_product_id: { _eq: $product_id } }) {
      color
      created_at
      id
      price
      sold_amount
      variation_image_url
      variation_name
      disabled
      customization_model {
        id
        model_name
      }
    }
  }
`;

export const PRODUCT_VARIATIONS_BY_PK = gql`
  query Product_variations_by_pk($id: ID!) {
    product_variations_by_pk(id: $id) {
      color
      created_at
      id
      price
      sold_amount
      variation_image_url
      variation_name
      disabled
      customization_model {
        id
        model_name
      }
    }
  }
`;

export const CREATE_PRODUCT = gql`
  mutation Insert_Products_One(
    $name: String!
    $price: numeric!
    $product_image_url: String!
    $barcode: String!
    $description: String!
    $category: uuid!
    $brand: uuid!
  ) {
    insert_products_one(
      object: {
        description: $description
        name: $name
        price: $price
        barcode: $barcode
        product_image_url: $product_image_url
        fk_product_category_id: $category
        fk_brand_id: $brand
      }
    ) {
      created_at
      description
      id
      name
      price
      product_image_url
      updated_at
      barcode
      brand_name {
        name
      }
    }
  }
`;

export const CREATE_PRODUCT_VARIATION = gql`
  mutation Insert_Product_Variations_One(
    $name: String!
    $image_url: String!
    $price: numeric!
    $product_id: uuid!
    $color: String
  ) {
    insert_product_variations_one(
      object: {
        fk_product_id: $product_id
        price: $price
        variation_image_url: $image_url
        variation_name: $name
        color: $color
      }
    ) {
      color
      created_at
      id
      price
      sold_amount
      variation_image_url
      variation_name
    }
  }
`;

export const DELETE_PRODUCT_VARIATION = gql`
  mutation Delete_Product_Variations_By_Pk($id: uuid!, $image_name: String!) {
    delete_product_variations_by_pk(id: $id) {
      id
    }
    deleteImage(imageName: $image_name) {
      error
      message
    }
  }
`;

export const DELETE_PRODUCT = gql`
  mutation Delete_Products_by_pk($id: uuid!, $image_name: String!) {
    delete_products_by_pk(id: $id) {
      id
    }
    deleteImage(imageName: $image_name) {
      error
      message
    }
  }
`;

export const ACTION_PRODUCT = gql`
  mutation Action_Product($id: uuid!, $action: Boolean!) {
    update_products_by_pk(
      pk_columns: { id: $id }
      _set: { disabled: $action }
    ) {
      created_at
    }
  }
`;

export const ACTION_PRODUCT_VARIATION = gql`
  mutation Action_Product_Variation($id: uuid!, $disabled: Boolean!) {
    update_product_variations_by_pk(
      pk_columns: { id: $id }
      _set: { disabled: $disabled }
    ) {
      created_at
      disabled
    }
  }
`;

export const UPDATE_PRODUCT = gql`
  mutation Update_Product_By_Id(
    $id: uuid!
    $description: String
    $discount: Boolean
    $brand: uuid
    $category: uuid
    $name: String
    $price: numeric
    $product_image_url: String
    $barcode: String!
    $review: Boolean
  ) {
    update_products_by_pk(
      pk_columns: { id: $id }
      _set: {
        description: $description
        discount_eligible: $discount
        fk_brand_id: $brand
        fk_product_category_id: $category
        name: $name
        barcode: $barcode
        price: $price
        product_image_url: $product_image_url
        show_reviews: $review
      }
    ) {
      created_at
      description
      id
      name
      price
      product_image_url
      updated_at
      barcode
      brand_name {
        name
      }
    }
  }
`;

export const UPDATE_PRODUCT_VARIATION = gql`
  mutation Update_Product_Variation_By_Id(
    $id: uuid!
    $color: String
    $price: numeric
    $image_url: String
    $name: String
    $model_id: uuid
  ) {
    update_product_variations_by_pk(
      pk_columns: { id: $id }
      _set: {
        color: $color
        price: $price
        variation_image_url: $image_url
        variation_name: $name
        model_id: $model_id
      }
    ) {
      created_at
      fk_product_id
      id
      price
      updated_at
      variation_image_url
      variation_name
    }
  }
`;

export const CREATE_PRODUCT_PHOTO = gql`
  mutation Insert_Product_Photos($image_url: String!, $id: uuid!) {
    insert_product_photos_one(
      object: { product_image_url: $image_url, fk_product_id: $id }
    ) {
      id
    }
  }
`;

export const DELETE_PRODUCT_PHOTO = gql`
  mutation Delete_Product_Photos_By_Id($image_name: String!, $id: uuid!) {
    delete_product_photos_by_pk(id: $id) {
      id
    }
    deleteImage(imageName: $image_name) {
      error
      message
    }
  }
`;

export const UPDATE_POSITION = gql`
  mutation Update_Product($id: uuid!, $updateAt: timestamptz!) {
    update_products_by_pk(
      pk_columns: { id: $id }
      _set: { updated_at: $updateAt }
    ) {
      id
    }
  }
`;

// ============================================================================
// DIRECT DISCOUNT MUTATIONS
// ============================================================================

/**
 * Apply direct discount to product
 */
export const APPLY_PRODUCT_DIRECT_DISCOUNT = gql`
  mutation ApplyProductDirectDiscount(
    $productId: uuid!
    $discountType: String!
    $discountValue: numeric!
    $startDate: timestamptz
    $endDate: timestamptz
    $label: String
  ) {
    update_products_by_pk(
      pk_columns: { id: $productId }
      _set: {
        has_direct_discount: true
        direct_discount_type: $discountType
        direct_discount_value: $discountValue
        direct_discount_start_date: $startDate
        direct_discount_end_date: $endDate
        direct_discount_label: $label
        direct_discount_created_at: "now()"
        direct_discount_updated_at: "now()"
      }
    ) {
      id
      name
      price
      original_price
      has_direct_discount
      direct_discount_type
      direct_discount_value
      direct_discount_label
    }
  }
`;

/**
 * Remove direct discount from product
 */
export const REMOVE_PRODUCT_DIRECT_DISCOUNT = gql`
  mutation RemoveProductDirectDiscount($productId: uuid!) {
    update_products_by_pk(
      pk_columns: { id: $productId }
      _set: {
        has_direct_discount: false
        original_price: null
        direct_discount_type: null
        direct_discount_value: null
        direct_discount_start_date: null
        direct_discount_end_date: null
        direct_discount_label: null
        direct_discount_updated_at: "now()"
      }
    ) {
      id
      name
      price
      has_direct_discount
    }
  }
`;

/**
 * Update direct discount on product
 */
export const UPDATE_PRODUCT_DIRECT_DISCOUNT = gql`
  mutation UpdateProductDirectDiscount(
    $productId: uuid!
    $discountType: String
    $discountValue: numeric
    $startDate: timestamptz
    $endDate: timestamptz
    $label: String
  ) {
    update_products_by_pk(
      pk_columns: { id: $productId }
      _set: {
        direct_discount_type: $discountType
        direct_discount_value: $discountValue
        direct_discount_start_date: $startDate
        direct_discount_end_date: $endDate
        direct_discount_label: $label
        direct_discount_updated_at: "now()"
      }
    ) {
      id
      name
      has_direct_discount
      direct_discount_type
      direct_discount_value
      direct_discount_label
    }
  }
`;

/**
 * Apply direct discount to product variation
 */
export const APPLY_VARIATION_DIRECT_DISCOUNT = gql`
  mutation ApplyVariationDirectDiscount(
    $variationId: uuid!
    $discountType: String!
    $discountValue: numeric!
    $startDate: timestamptz
    $endDate: timestamptz
    $label: String
  ) {
    update_product_variations_by_pk(
      pk_columns: { id: $variationId }
      _set: {
        has_direct_discount: true
        direct_discount_type: $discountType
        direct_discount_value: $discountValue
        direct_discount_start_date: $startDate
        direct_discount_end_date: $endDate
        direct_discount_label: $label
        direct_discount_created_at: "now()"
        direct_discount_updated_at: "now()"
      }
    ) {
      id
      variation_name
      price
      original_price
      has_direct_discount
      direct_discount_type
      direct_discount_value
    }
  }
`;

/**
 * Remove direct discount from product variation
 */
export const REMOVE_VARIATION_DIRECT_DISCOUNT = gql`
  mutation RemoveVariationDirectDiscount($variationId: uuid!) {
    update_product_variations_by_pk(
      pk_columns: { id: $variationId }
      _set: {
        has_direct_discount: false
        original_price: null
        direct_discount_type: null
        direct_discount_value: null
        direct_discount_start_date: null
        direct_discount_end_date: null
        direct_discount_label: null
        direct_discount_updated_at: "now()"
      }
    ) {
      id
      variation_name
      price
      has_direct_discount
    }
  }
`;

/**
 * Update direct discount on product variation
 */
export const UPDATE_VARIATION_DIRECT_DISCOUNT = gql`
  mutation UpdateVariationDirectDiscount(
    $variationId: uuid!
    $discountType: String
    $discountValue: numeric
    $startDate: timestamptz
    $endDate: timestamptz
    $label: String
  ) {
    update_product_variations_by_pk(
      pk_columns: { id: $variationId }
      _set: {
        direct_discount_type: $discountType
        direct_discount_value: $discountValue
        direct_discount_start_date: $startDate
        direct_discount_end_date: $endDate
        direct_discount_label: $label
        direct_discount_updated_at: "now()"
      }
    ) {
      id
      variation_name
      has_direct_discount
      direct_discount_type
      direct_discount_value
      direct_discount_label
    }
  }
`;

/**
 * Bulk apply direct discount to multiple products
 */
export const BULK_APPLY_PRODUCT_DISCOUNT = gql`
  mutation BulkApplyProductDiscount(
    $productIds: [uuid!]!
    $discountType: String!
    $discountValue: numeric!
    $startDate: timestamptz
    $endDate: timestamptz
    $label: String
  ) {
    update_products(
      where: { id: { _in: $productIds } }
      _set: {
        has_direct_discount: true
        direct_discount_type: $discountType
        direct_discount_value: $discountValue
        direct_discount_start_date: $startDate
        direct_discount_end_date: $endDate
        direct_discount_label: $label
        direct_discount_created_at: "now()"
        direct_discount_updated_at: "now()"
      }
    ) {
      affected_rows
      returning {
        id
        name
        has_direct_discount
      }
    }
  }
`;

/**
 * Bulk remove direct discount from multiple products
 */
export const BULK_REMOVE_PRODUCT_DISCOUNT = gql`
  mutation BulkRemoveProductDiscount($productIds: [uuid!]!) {
    update_products(
      where: { id: { _in: $productIds } }
      _set: {
        has_direct_discount: false
        original_price: null
        direct_discount_type: null
        direct_discount_value: null
        direct_discount_start_date: null
        direct_discount_end_date: null
        direct_discount_label: null
        direct_discount_updated_at: "now()"
      }
    ) {
      affected_rows
      returning {
        id
        name
        has_direct_discount
      }
    }
  }
`;

/**
 * Get all products with active direct discounts
 */
export const GET_DISCOUNTED_PRODUCTS = gql`
  query GetDiscountedProducts(
    $limit: Int
    $offset: Int
    $discountType: String
  ) {
    products(
      limit: $limit
      offset: $offset
      where: {
        has_direct_discount: { _eq: true }
        _and: [
          { _or: [
            { direct_discount_type: { _eq: $discountType } }
            { _is_null: { direct_discount_type: $discountType } }
          ]}
        ]
        _or: [
          { direct_discount_start_date: { _is_null: true } }
          { direct_discount_start_date: { _lte: "now()" } }
        ]
        _or: [
          { direct_discount_end_date: { _is_null: true } }
          { direct_discount_end_date: { _gte: "now()" } }
        ]
      }
      order_by: { direct_discount_created_at: desc }
    ) {
      id
      name
      price
      original_price
      has_direct_discount
      direct_discount_type
      direct_discount_value
      direct_discount_label
      direct_discount_start_date
      direct_discount_end_date
      product_image_url
      category {
        id
        product_category_name
      }
      brand_name {
        name
      }
    }
    products_aggregate(
      where: {
        has_direct_discount: { _eq: true }
      }
    ) {
      aggregate {
        count
      }
    }
  }
`;
